import React, { useState } from "react";
import { Box, ToggleButtonGroup, ToggleButton } from "@mui/material";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import TableChartOutlinedIcon from "@mui/icons-material/TableChartOutlined";
import UserRolesManager from "./UserRolesManager";
import RolePermissionsView from "./RolePermissionsView";

const RolesTab = () => {
  const [view, setView] = useState("byUser");

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <ToggleButtonGroup
          value={view}
          exclusive
          onChange={(_, v) => v && setView(v)}
          size="small"
        >
          <ToggleButton value="byUser">
            <PeopleOutlinedIcon sx={{ mr: 0.5, fontSize: 18 }} />
            Roles by User
          </ToggleButton>
          <ToggleButton value="byRole">
            <TableChartOutlinedIcon sx={{ mr: 0.5, fontSize: 18 }} />
            Permissions by Role
          </ToggleButton>
        </ToggleButtonGroup>
      </Box>

      {view === "byUser" ? <UserRolesManager /> : <RolePermissionsView />}
    </Box>
  );
};

export default RolesTab;
